import { axios } from '@/lib/axios';

export const getStores = async () => {
    const { data } = await axios.get(`/v1/admin/locations/get-locations`);
    return data.locations;
};
